/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$('span.ProductForm__SelectedValue').bind('DOMSubtreeModified', function() {
  console.log("===")
  if ($('span.ProductForm__SelectedValue').length === $('span.ProductForm__SelectedValue:contains("Custom Single")').length) {
    $("#hideField").show();
  } else {
    $("#hideField").hide();
    $("input#custom-wording").val("");
  }
});
/* -- Code for Make a Selection option -- */
$(document).ready(function() {
  console.log(productOptions);
  if( typeof(productOptions ) != "undefined" ){
    for(i=0;i<productOptions.length;i++) {
      $('.single-option-selector-product:eq('+ i +')')
      .filter(function() {
        return $(this).find('option').length > 1
      })
      .prepend('<option value="">Pick a ' + productOptions[i][i] + '</option>')
      .val('')
      .trigger('change');
    }
  }
  if($(".SizeSwatch__Radio:checked").val() == "Custom Single"){
    console.log("Show Input");
    $("#hideField").show();
  }
  $(document).on("click", ".SizeSwatch", function(){
    if($(this).data("value") == "Custom Single"){
//       $('html, body').animate({
//         scrollTop: $("div.product-form__controls-group").offset().top-220
//       }, 2000);
      $("#hideField").show();
        $('#custom-wording').attr("name", "properties[Custom Wording]");
    }else{
      $("#hideField").hide();
      $('#custom-wording').attr("name", "");
    }
  });
  $(document).on("click", ".ColorSwatch ", function(){
    $(".selected-color-name").text($(this).data("color"))
  });
});
/* - end - */